import type {JSX} from 'react';
import {useNavigate} from 'react-router-dom';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {useInbox} from '../hooks/useInbox';
import {useGmailConnection} from '../hooks/useGmailConnection';
import {InboxOverview, InboxMetrics} from '../components/inbox/InboxOverview';
import {TicketFilters} from '../components/inbox/TicketFilters';
import {TicketQueue} from '../components/inbox/TicketQueue';
import {TicketDetail} from '../components/TicketDetail';
import {TriageInspector} from '../components/TriageInspector';
import {EmptyState} from '../components/Shared';

export default function InboxPage(): JSX.Element {
  const {tickets, selected, setSelected, setNewOpen} = useWorkspace();
  const inbox = useInbox(tickets, selected);
  const connection = useGmailConnection();
  const navigate = useNavigate();
  const connected = Boolean(connection.gmail?.connected);
  const selectTicket = (id: string): void => { setSelected(id); inbox.patch({mobileDetail: true}); };
  const sync = (): void => { if (connected) void connection.sync(); else navigate('/connections'); };
  return <div className="inbox-page page-enter">
    <InboxOverview tickets={tickets} connected={connected} syncing={connection.busy === 'sync'} onSync={sync}/>
    <InboxMetrics tickets={tickets} counts={inbox.counts}/>
    <TicketFilters filters={inbox.filters} counts={inbox.counts} onChange={inbox.patch}/>
    <div className={`workbench ${inbox.filters.mobileDetail ? 'mobile-detail' : ''}`}>
      <TicketQueue tickets={inbox.filtered} activeId={inbox.active?.id} query={inbox.filters.query}
        onQuery={query => inbox.patch({query})} onSelect={selectTicket} hasTickets={Boolean(tickets.length)} onClear={inbox.reset} onNew={() => setNewOpen(true)}/>
      {inbox.active ? <><TicketDetail key={inbox.active.id} ticket={inbox.active} onBack={() => inbox.patch({mobileDetail: false})}/><TriageInspector ticket={inbox.active}/></> :
        <div className="ticket-detail"><EmptyState title="Room for your next conversation" id="empty-workbench"><p>Choose a ticket from your inbox or add a new message.</p></EmptyState></div>}
    </div>
  </div>;
}